// @ts-nocheck
import JoTooltip from '@jo-v1/features/JoTooltip';
import React, { JSX } from 'react';

import cn from '@core/utils/classNames';

import styles from './AdditionalInfoCard.module.css';

interface SchoolAdditionalInfo {
  icon: JSX.Element;
  title: string;
  value: string;
  hasTooltip?: boolean;
  tooltipText?: string;
  centeredContent?: boolean;
  hasBorder?: boolean;
}

export const AdditionalInfoCard = ({
  icon,
  title,
  value,
  hasTooltip,
  tooltipText,
  centeredContent,
  hasBorder,
}: SchoolAdditionalInfo) => {
  const displayValue = value;

  return (
    <div className={cn(styles.schoolInfoCard, centeredContent && styles.centered, hasBorder && styles.hasBorder)}>
      <span className={styles.icon}>{icon}</span>
      <div className={styles.titleContainer}>
        <span className={styles.title}>{title}</span>
        {hasTooltip && (
          <JoTooltip
            text={
              <>
                <h4>{title}</h4>
                {tooltipText}
              </>
            }
          />
        )}
      </div>
      <div className={styles.valueContainer}>
        <span className={styles.value}>{displayValue}</span>
      </div>
    </div>
  );
};

export default AdditionalInfoCard;
